import type { Event } from '@sentry/vue'
import { init, browserTracingIntegration, replayIntegration } from '@sentry/vue'
import type { App } from 'vue'
import forEach from 'lodash.foreach'
import isObject from 'lodash.isobject'
import type { Router } from 'vue-router'
import { version } from '../../package.json'

const initSentry = (app: App | App[], router: Router) => {
  if (import.meta.env.VITE_APP_SENTRY_URL) {
    const keysToFilter = ['email', 'lastName', 'firstName', 'phoneNumber']

    const filterCondition = (key: string): boolean => keysToFilter.includes(key)

    type FilterFunction = typeof filterCondition

    const deepFilter = (
      collection: object | any[] | Event | EventTarget,
      filter: FilterFunction
    ) => {
      // iterate the collection
      forEach(collection, (val, key) => {
        // clear value if key meets filter condition
        if (filter(key)) {
          // eslint-disable-next-line no-param-reassign
          delete collection[key as keyof typeof collection]
        } else if (isObject(val)) {
          // if key doesn't meet condition, but value is collection
          // recur
          deepFilter(val, filter)
        }
      })
    }

    init({
      app,
      dsn: import.meta.env.VITE_APP_SENTRY_URL,
      environment: import.meta.env.VITE_APP_SENTRY_ENVIRONMENT,
      release: `${import.meta.env.VITE_APP_SENTRY_PROJECT_NAME}@${version}`,
      integrations: [browserTracingIntegration({ router }), replayIntegration()],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      beforeSend(event) {
        deepFilter(event, filterCondition)
        return event
      }
    })
  }
}
export default initSentry
